import gql from 'graphql-tag'
import { useQuery } from "@apollo/client";

const impersonationRightsQuery = gql`
    query impersonationRights(
        $tenantGuid: String!
        $currentPage: Int!
        $pageSize: Int!
        $where: ImpersonationRightWhereInput 
    ) {
        impersonationRights(
            currentPage: $currentPage
            pageSize: $pageSize
            where: $where
            tenantGuid: $tenantGuid
        ) {
            meta {
                currentPage
                lastPage
                pageSize
                totalCount
            }
            nodes {
                id
                key
                expirationDateTime
                puppetUserId
            }
        }
    }
`

const useFetchImpersonationRights = (options) => {
    const variables = {
        pageSize: 99,
        currentPage: 1,
        ...options,
    }
    const {
        data = {
            impersonationRights: {},
        },
        error,
        loading,
    } = useQuery(impersonationRightsQuery, {
        variables,
    })

    const refetchQueries = [
        {
            query: impersonationRightsQuery,
            variables,
        },
    ]

    return {
        error,
        isFetching: loading,
        impersonationRights: loading ? [] : data?.impersonationRights?.nodes,
        refetchQueries,
    }
}

export default useFetchImpersonationRights
